import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-relative slide-card card-border max-size inset-shadow" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "p-absolute fs-22 fw-700 light-light-color ion-text-center slide-card-text" }
const _hoisted_4 = { class: "fs-small" }
const _hoisted_5 = { class: "fs-small" }

import { alertController, IonCol, IonGrid, IonRow } from "@ionic/vue";
import { computed } from "vue";
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/vue";

import LanguageDropdown from "@/components/selects/LanguageDropdown.vue";
import LogoRow from "@/components/LogoRow.vue";
import ButtonFix from "@/components/button/ButtonFix.vue";

import { usePersistentStore } from "@/stores/persistent";

import { useLanguageArray } from "@/composables/useLanguageArray";
import { useApi } from "@/composables/useApi";

import { BUTTON_FILL, ION_VARIANT } from "@/types/enum/ionicEnum";
import { StartScreenInterfaceEmits } from "@/types/emits";

import { swiperBreakpointsPromotion } from "@/assets/variables";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { isApp } from "@/functions/enviroment";


export default /*@__PURE__*/_defineComponent({
  __name: 'StartScreenInterface',
  emits: ["login", "register"],
  setup(__props) {



const persistentStore = usePersistentStore()
const { changeURL } = useApi()

const initSlides = [
    { text: 'messages.home.image1', img: 'assets/devImages/slider1.png' },
    { text: 'messages.home.image2', img: 'assets/devImages/slide2.svg' },
    { text: 'messages.home.image3', img: 'assets/devImages/slider3.png' },
]

// mobile view → 6 slides
const slidesArray = [...initSlides, ...initSlides];
// desctop view → 9 slides
if (window.innerWidth > 1920) slidesArray.push(...initSlides)

const articlePromotions = useLanguageArray(slidesArray, 'text')

const standardURL = process.env.VUE_APP_ROOT_API
let timeout: number | undefined = undefined

const sliderItems = computed(() => articlePromotions.content ? articlePromotions.content : [])

const openURLAlert = async (): Promise<void> => {
    const alertParams = {
        message: 'Welchen Server möchtest du verwenden?',
        header: 'Server wechseln',
        cssClass: 'custom-alert',
        inputs: [
            {
                placeholder: 'API URL',
                cssClass: 'purple-purple-color background-color-light purple-purple-alert-input',
                value: 'https://api-v3.dev.ordersystems.net/api/'
            }
        ],
        buttons: [
            {
                text: 'Standard',
                handler: () => {
                    changeURL(standardURL)
                },
            },
            {
                text: 'OK',
                handler: (value: string[]) => {
                    changeURL(value[0])
                },
            }
        ],
    }

    const alert = await alertController.create(alertParams);
    await alert.present();
}

const startTimer = (): void => {
    timeout = setTimeout(() => {
        openURLAlert()
        timeout = undefined;
    }, 10000);
}

const endTimer = (): void => {
    if (timeout) {
        clearTimeout(timeout);
        timeout = undefined;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonGrid), { class: "remove-specific-padding max-height d-flex flex-d-c" }, {
    default: _withCtx(() => [
      _createVNode(LogoRow, {
        onMousedown: _cache[0] || (_cache[0] = ($event: any) => (startTimer())),
        onMouseup: _cache[1] || (_cache[1] = ($event: any) => (endTimer())),
        onTouchstart: _cache[2] || (_cache[2] = ($event: any) => (startTimer())),
        onTouchend: _cache[3] || (_cache[3] = ($event: any) => (endTimer()))
      }),
      (_unref(persistentStore).apiUrl !== _unref(standardURL))
        ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "center-x" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(persistentStore).apiUrl), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonRow), {
        class: "no-padding-x-row swiper-row pt-1",
        style: {"min-height":"290px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), null, {
            default: _withCtx(() => [
              (sliderItems.value.length)
                ? (_openBlock(), _createBlock(_unref(Swiper), {
                    key: 0,
                    class: _normalizeClass(["custom-pagination start-slider force-equal-height-slides", {'web-slider': !_unref(isApp)()}]),
                    "space-between": 8,
                    pagination: { clickable: true, type: 'bullets' },
                    breakpoints: _unref(swiperBreakpointsPromotion),
                    slideToClickedSlide: true,
                    centeredSlides: true,
                    loop: true,
                    modules: [_unref(Pagination)],
                    effect: "cards"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sliderItems.value, (promotion, ind) => {
                        return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: ind }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                              _createElementVNode("img", {
                                alt: "",
                                src: promotion.img,
                                class: "card-border max-size",
                                style: {"object-fit":"cover"}
                              }, null, 8, _hoisted_2),
                              _createElementVNode("div", _hoisted_3, _toDisplayString(promotion.text), 1)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class", "breakpoints", "modules"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonRow), {
        class: "pb-1 flex-grow-2",
        style: {"min-height":"80px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), { class: "center-y flex-d-c ion-justify-content-end" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('messages.start.notNew')) + "? ", 1),
              _createVNode(ButtonFix, {
                color: _unref(ION_VARIANT).LIGHT,
                class: "coral-coral-color light-light-background light-medium-shadow",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('login')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('button.login')), 1)
                ]),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonRow), {
        class: "flex-grow-2",
        style: {"min-height":"80px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), { class: "center-y flex-d-c ion-justify-content-start" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('messages.start.new')) + "? ", 1),
              _createVNode(ButtonFix, {
                fill: _unref(BUTTON_FILL).OUTLINE,
                class: "coral-light-color",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('register')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('button.register')), 1)
                ]),
                _: 1
              }, 8, ["fill"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonRow), {
        class: "mt-3",
        style: {"min-height":"50px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), { class: "center-x" }, {
            default: _withCtx(() => [
              _createVNode(LanguageDropdown, { class: "ml-1 mb-1" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})